import { cn } from '@/libs';
interface ICardProps {
  Icon: React.ElementType;
  title: string;
  value: string;
  className?: {
    container?: string;
    title?: string;
    value?: string;
    icon?: string;
  };
}
export const Card: React.FC<ICardProps> = ({
  Icon,
  title,
  value,
  className
}) => {
  return <div className={cn('anim-config anim-translate-4 rounded-lg border border border-foreground/10 bg-foreground/5 p-4', className?.container)}>
      <div className='flex items-center justify-between'>
        <div>
          <p className={cn('text-foreground/60 text-sm', className?.title)}>
            {title}
          </p>
          <p className={cn('font-bold text-2xl', className?.value)}>{value}</p>
        </div>
        <Icon className={cn('size-8', className?.icon)} />
      </div>
    </div>;
};